import React from 'react';

import { Stack, xcss } from '@atlaskit/primitives';

import { type Recommendation } from '../pm-plugins/ai-proactive/api';

import { RecommendationItem } from './recommendation-item';

const listStyles = xcss({
	paddingInlineStart: 'space.0',
});

type RecommendationListProps = {
	recommendations: Recommendation[];
	onApply: ({ recommendation }: { recommendation: Recommendation }) => void;
	onDismiss: ({ recommendation }: { recommendation: Recommendation }) => void;
};

export const RecommendationList = (props: RecommendationListProps) => {
	const { recommendations, onApply, onDismiss } = props;
	return (
		<Stack as="ul" xcss={listStyles}>
			{recommendations?.map((r) => (
				<RecommendationItem
					key={r.id}
					id={r.id}
					action={r.transformAction}
					onApply={() => onApply({ recommendation: r })}
					onDismiss={() => onDismiss({ recommendation: r })}
				></RecommendationItem>
			))}
		</Stack>
	);
};
